// Demand · Redemption — the redemption-side work surface. D1 / D2 / D3
// sections, each with a live chart, must-win category drill-down, vendors
// with their own actions, and a demand-filtered ledger at the bottom.
//
// Cut 6.2 (3 Jun 2026): row taxonomy moved to the 11 partner-report
// categories. Categories.ts now carries partner-aligned metrics (today,
// target, retention, consignment, settlement) sourced from the End-April
// Partners Report + 2-Jun 1-pager. Same KPI-block layout, new content.

import { SideDashboard } from "../components/SideDashboard";

export function DemandPage() {
  return <SideDashboard side="demand" />;
}
